import styled, { css } from "styled-components";
import React, { useState, useEffect } from "react";
import TextKeyValue from "./Text/TextKeyValue";
import TextParagraph from "./Text/TextParagraph";
import BtnIcon from "./Btn/BtnIcon";
import { useHistory } from "react-router-dom";
import { NowDataProps } from "Components/HomeView";
import Dim from "./Dim";
import Thumbnail from "./SourceImage";
import media, { BREAKPOINT_TABLET } from "Styles/media";
import useWindowSize from "Hooks/useWindowSize";
import { useHeaderState } from "Provider/AppProvider";

interface PopupPlanetProps {
	data: NowDataProps | undefined;
	setNowId: any | undefined;
}

const Wrapper = styled.div`
	cursor: auto;
	height: 100%;
	position: relative;
	${(props) => props.theme.event.disable};
	z-index: ${(props) => props.theme.zIndex.popup};
`;

const DimCustom = styled(Dim)`
	transition-duration: ${(props) => props.theme.transition.popup.duration};
`;

const Inner = styled.div<{ active: boolean }>`
	z-index: ${(props) => props.theme.zIndex.popup};
	position: absolute;
	top: 50%;
	left: 50%;
	transform: translate(-50%, -50%);
	color: white;
	border: 1px solid ${(props) => props.theme.color.white};
	${(props) => (props.active ? props.theme.event.able : props.theme.event.disable)};
	width: 560px;
	background-color: ${(props) => props.theme.color.bg};
	transition: ${(props) => props.theme.transition.default};
	transition-duration: ${(props) => props.theme.transition.popup.duration};
	/* opacity: 0; */
	overflow: hidden;
	${(props) => props.theme.layout.scroll_hide};

	${(props) =>
		props.active
			? css`
					opacity: 1;
			  `
			: css`
					opacity: 0;
			  `};

	@media ${media.tablet} {
		width: 100%;
		height: 100%;
		overflow: scroll;
		${(props) => props.theme.layout.scroll_hide};
		min-width: initial;
		border: none;
		background-color: transparent;

		${(props) =>
		props.active
			? css`
						opacity: 1;
						transform: translate(-50%, -50%) translateY(0);
				  `
			: css`
						opacity: 0;
						transform: translate(-50%, -50%) translateY(100%);
				  `};
	}
`;

const Col = styled.div``;

const Header = styled(Col)`
	display: flex;
	justify-content: space-between;
	align-items: center;
	padding: 12px;

	@media ${media.tablet} {
		padding: ${(props) => `${props.theme.size.offset.tablet}px`};
	}
`;

const BtnClose = styled(BtnIcon)``;

const InfoWrapper = styled.div`
	margin-bottom: 18px;
`;

const DescriptWrapper = styled.div`
	padding: 12px;

	@media ${media.tablet} {
		padding: ${(props) => `${props.theme.size.offset.tablet}px`};
	}
`;
const Descript = styled(TextParagraph)`
	margin-bottom: 18px;
	/* 한 줄 자르기 */
`;
const BtnWrapper = styled.div`
	margin-bottom: 8px;
	display: flex;
	justify-content: flex-end;
`;
const BtnExplorer = styled(BtnIcon)``;

const PopupPlanet: React.FC<PopupPlanetProps> = ({ data, setNowId }) => {
	const [isImageLoaded, setIsImageLoaded] = useState(false);
	const [popupActive, setPopupActive] = useState(false);
	const { setHeaderState } = useHeaderState();
	const { push } = useHistory();
	const { size } = useWindowSize();

	useEffect(() => {
		if (data) {
			const src = data.thumbnail;
			const dom = document.createElement("img");
			dom.src = src;
			const imageOnLoaded = () => {
				setIsImageLoaded(true);
			};
			dom.addEventListener("load", imageOnLoaded);
			return () => {
				dom.removeEventListener("load", imageOnLoaded);
				setIsImageLoaded(false);
			};
		}
	}, [data]);

	useEffect(() => {
		if (isImageLoaded && data) {
			setPopupActive(true);
		}
		return () => setPopupActive(false);
	}, [data, isImageLoaded]);

	useEffect(() => {
		setHeaderState((n) => ({ ...n, disable: data ? true : false }));
	}, [data, setHeaderState]);

	const handleDetailClick = (id: string) => {
		push(`/planet?id=${id}`);
	};

	const handleCloseClick = () => {
		setPopupActive(false);
		setNowId("");
	};

	return (
		<Wrapper>
			<DimCustom active={!!data} line={size.width <= BREAKPOINT_TABLET ? false : true} />

			<Inner active={popupActive} id={"popup"}>
				{data && isImageLoaded && (
					<>
						<Header>
							<TextParagraph value={data.title} />
							<BtnClose icon="close" onClick={handleCloseClick} />
						</Header>
						<Col onClick={() => handleDetailClick(data.id)}>
							<Thumbnail image={data.thumbnail} />
						</Col>
						<Col>
							<DescriptWrapper>
								<InfoWrapper>
									<TextKeyValue keyText={"Owner"} value={data.user.name} />
								</InfoWrapper>
								<Descript value={data.descript} row={3} />
								<BtnWrapper>
									<BtnExplorer icon="right" onClick={() => handleDetailClick(data.id)} text={"탐험하기"} />
								</BtnWrapper>
							</DescriptWrapper>
						</Col>
					</>
				)}
			</Inner>
		</Wrapper>
	);
};

export default PopupPlanet;
